<template>
  <div class="authResultBody">
    <div class="authResultMain">
      <div v-if="verifyMsg" class="authenticationResult">
        <img src="@/assets/image/fail.png">
        <h2>认证不通过</h2>
        <dl>
          <dt>不通过原因：</dt>
          <dd>{{ verifyMsg }}</dd>
        </dl>
        <div>
          <el-button type="primary" size="small" @click="blockFace">重新认证</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['verifyMsg', 'face', 'authAgentBalck', 'authAgent', 'indexBack'],
  methods: {
    blockAuth() {
      this.$emit('blockAuth')
    },
    blockFace() {
      if (this.authAgent) {
        //办理人未认证
        this.$router.push({ name: 'companyAgentScanningCode' }) //法人
        this.$emit('blockAgentFace') //经办人
      } else if (this.authAgentBalck) {
        //办理人三次失败
        this.$router.push({ name: 'companyEntryInfo' })
      } else {
        this.getAuthTimes()
      }
    },
    getAuthTimes() {
      this.$api
        .getBackStep({ flowId: this.$store.state.userInfo.flowId })
        .then(res => {
          if (res.code && res.code === '0') {
            if (this.indexBack) {
              //首页
              this.$emit('blockFace')
            } else if (
              res.data.remainAuthTimeVOS.findIndex(item => {
                return (
                  item.authPath === 'ENTERPRISE_LEGAL_PERSON' &&
                  item.remainTime > 0
                )
              }) >= 0 //有认证次数
            ) {
              this.$emit('blockFace')
            } else {
              this.$router.push({ name: 'companyEntryInfo' })
            }
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          this.$alert(err.msg, '提示', {
            confirmButtonText: '好的',
            callback: () => {
              if (err.code === '810404') {
                window.location.href = this.$store.state.userInfo.preWebUrl
              } else if (this.indexBack) {
                this.$emit('blockFace')
              } else {
                this.$router.push({ name: 'companyEntryInfo' })
              }
            }
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.authResultBody {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  background: #f1f3f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.authResultMain {
  width: 1600px;
  flex: 1;
  min-height: 800px;
  margin: 16px auto 0;
  background: #fff;
  padding: 0px 0 40px;
}
.authenticationResult {
  width: max-content;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 120px;
    margin-top: 52px;
  }
  h2 {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    line-height: 27px;
    letter-spacing: 1px;
    margin-top: 18px;
  }
  h5 {
    margin: 8px 0 32px;
    font-size: 14px;
    color: #929292;
    line-height: 22px;
    font-weight: normal;
  }
  dl {
    width: 450px;
    background: #f1f5ff;
    border-radius: 4px;
    padding: 16px;
    margin: 32px 0 70px;
  }
  dt {
    padding-left: 24px;
    background: url('~@/assets/image/warning.png') no-repeat;
    background-size: 16px;
    font-size: 14px;
    color: #333333;
    line-height: 19px;
    font-weight: bold;
  }
  dd {
    margin-top: 12px;
    font-size: 14px;
    color: #595959;
    line-height: 16px;
  }
}
</style>